declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    yaContextCb: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Ya: any;
  }
}

export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const script = document.createElement('script');
    script.src = 'https://yandex.ru/ads/system/context.js';
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      window.yaContextCb = window.yaContextCb || [];
    };
  }
});
